import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  username: "",
  firstname: "",
  lastname: "",
  email: "",
  roles: [],
  isNewDentist: false,
  showTerminatedCases: false,
};

const existingUser = JSON.parse(localStorage.getItem("user"));

export const userSlice = createSlice({
  name: "user",
  initialState: existingUser || initialState,
  reducers: {
    initUser: (state, { payload }) => {
      // string, string[], string
      state.id = payload.id;
      state.roles = payload.roles;
      state.username = payload.username;
      state.firstname = payload.firstname;
      state.lastname = payload.lastname;
      state.email = payload.email;
      localStorage.setItem(
        "user",
        JSON.stringify({
          id: payload.id,
          roles: payload.roles,
          firstname: payload.firstname,
          lastname: payload.lastname,
          email: payload.email,
        })
      );
    },
    showTerminatedCases: (state, { payload }) => {
      // string, string[], string
      state.showTerminatedCases = payload.showTerminatedCases;
    },

    setNewDentist: (state, { payload }) => {
      // bool
      state.isNewDentist = payload;

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...state,
          isNewDentist: payload,
        })
      );
    },
    removeUser: () => {
      localStorage.clear();
      return initialState;
    },
  },
});

export const { initUser, removeUser, setNewDentist } = userSlice.actions;

export default userSlice.reducer;
